module.exports = __webpack_public_path__ + "static/media/banner-img-wrp-img-1.a2ebdbe1.png";